import React, { useEffect } from 'react';
import { useContext } from 'react';
import { ThemeContext } from '../contexts/ThemeContext';
import { LanguageContext } from '../contexts/LanguageContext';
import { globalBuilder } from '../../archbuilder/GlobalBuilder';
import {
  ElementAttribute,
  ElementCard,
} from '../components/ElementCard/ElementCard';
import { Box } from '@mui/material';
import ElementCardGroup from '../components/ElementCard/ElementCardGroup';

export const Studies: React.FC = () => {
  const { theme, setThemes } = useContext(ThemeContext);
  const { t } = useContext(LanguageContext);

  useEffect(() => {
    setThemes(['pages', 'elementcards']);
  }, []);

  let turnOfLeft = false;

  const getTurn = () => {
    turnOfLeft = !turnOfLeft;
    return turnOfLeft;
  };

  const attributesList1: ElementAttribute[] = [
    {
      name: t('background/developer/description/tag'),
      content: t('background/developer/description/desc'),
    },
    {
      name: t('background/developer/period/tag'),
      content: t('background/developer/period/desc'),
    },
    {
      name: t('background/developer/link/tag'),
      content: t('background/developer/link/desc'),
      ref: t('background/developer/link/ref'),
      href: t('background/developer/link/href'),
    },
    {
      name: t('background/developer/link2/tag'),
      content: t('background/developer/link2/desc'),
      ref: t('background/developer/link2/ref'),
      href: t('background/developer/link2/href'),
    },
  ];

  const attributesList2: ElementAttribute[] = [
    {
      name: t('background/teacher/description/tag'),
      content: t('background/teacher/description/desc'),
    },
    {
      name: t('background/teacher/period/tag'),
      content: t('background/teacher/period/desc'),
    },
    {
      name: t('background/teacher/link1/tag'),
      content: t('background/teacher/link1/desc'),
      ref: t('background/teacher/link1/ref'),
      href: t('background/teacher/link1/href'),
    },
    {
      name: t('background/teacher/link2/tag'),
      content: t('background/teacher/link2/desc'),
      ref: t('background/teacher/link2/ref'),
      href: t('background/teacher/link2/href'),
    },
  ];

  const attributesList3: ElementAttribute[] = [
    {
      name: t('background/masters/subjects/tag'),
      content: t('background/masters/subjects/desc'),
    },
    {
      name: t('background/masters/period/tag'),
      content: t('background/masters/period/desc'),
    },
    {
      name: t('background/masters/link/tag'),
      content: t('background/masters/link/desc'),
      ref: t('background/masters/link/ref'),
      href: t('background/masters/link/href'),
    },
  ];

  const attributesList4: ElementAttribute[] = [
    {
      name: t('background/college/subjects/tag'),
      content: t('background/college/subjects/desc'),
    },
    {
      name: t('background/college/period/tag'),
      content: t('background/college/period/desc'),
    },
    {
      name: t('background/college/grades/tag'),
      content: t('background/college/grades/desc'),
    },
    {
      name: t('background/college/link/tag'),
      content: t('background/college/link/desc'),
      ref: t('background/college/link/ref'),
      href: t('background/college/link/href'),
    },
  ];

  const attributesList5: ElementAttribute[] = [
    {
      name: t('background/bach/subjects/tag'),
      content: t('background/bach/subjects/desc'),
    },
    {
      name: t('background/bach/period/tag'),
      content: t('background/bach/period/desc'),
    },
    {
      name: t('background/bach/grades/tag'),
      content: t('background/bach/grades/desc'),
    },
    {
      name: t('background/bach/link/tag'),
      content: t('background/bach/link/desc'),
      ref: t('background/bach/link/ref'),
      href: t('background/bach/link/href'),
    },
  ];

  return globalBuilder.Background(
    attributesList1,
    attributesList2,
    attributesList3,
    attributesList4,
    attributesList5,
    getTurn,
  );
};
